import Vue from 'vue'
import Vuex from 'vuex'
import axioss from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: '',
    token: localStorage.getItem('token_manager') || '',
    user : {},
    loader: false,
    request_error: '',
    alert: {
      color: '',
      visible: false,
      message: ''
    }
  },
  mutations: {
    auth_request(state){
      state.status = 'loading'
    },
    auth_success(state, token, user){
      state.status = 'success'
      state.token = token
      state.user = user
    },
    auth_error(state){
      state.status = 'error'
    },
    logout(state){
      state.status = ''
      state.token = ''
    },
    loader(state, payload){
      state.loader = payload
    },
    t(){

    },
    sucesso(state, msg){ 
      state.alert.color = 'success'
      state.alert.message = msg
      state.alert.visible = true
    },

    erro(state, msg){
      state.alert.color = 'error'
      state.alert.message = msg
      state.alert.visible = true
    },

  },
  actions: {

    login({commit}, user){
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axioss({url: `${process.env.VUE_APP_URL_API}/auth/login`, data: user, method: 'POST' })
        .then(resp => {
          const token = resp.data.access_token
          const user = ''
          localStorage.setItem('token_manager', token)
          axioss.defaults.headers.common['Authorization'] = `Bearer ${token}`
          commit('auth_success', token, user)
          resolve(resp)
        })
        .catch(err => {
          commit('auth_error')
          localStorage.removeItem('token_manager')
          reject(err)
        })
      })
    },

    logout({commit}){
      return new Promise((resolve, reject) => {
        commit('logout')
        localStorage.removeItem('token_manager')
        delete axioss.defaults.headers.common['Authorization']
        resolve()
        reject()
      })
    },

    /** FILIAL */

    // eslint-disable-next-line no-unused-vars
    obterFiliais({commit}){
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/filial`, params:{size:9999999}, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    obterFilial({commit}, id_reg){
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/filial/${id_reg}`, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },



    pesquisarFilial({commit}, obj){
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/filial`, params:obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    salvarFilial({commit}, obj){
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/filial`, data:obj, method: 'POST'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    replicarFilial({commit}, obj){
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/filial/replicador`, data:obj, method: 'POST'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    getRegimeTributario(){
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/filial/regimetributario`, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /** certificados */
    salvarCertificado({commit}, obj){
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/certificado`, data: obj, method: 'POST', headers:{'Content-Type': 'multipart/form-data'}})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    obterCertificado({commit}, id_reg){
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/certificado/${id_reg}/dados`, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /** GERAL */
    getEstados(){
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/estado`, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    // eslint-disable-next-line no-unused-vars
    getMunicipios({commit}, obj){
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/municipio/${obj.cc_est}`, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /* PRODUTOS */

    // eslint-disable-next-line no-unused-vars
    obterCFOP ({commit}) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/produto/cfop`, params: {}, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    // eslint-disable-next-line no-unused-vars
    obterOrigem ({commit}) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/produto/origem`, params: {}, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    // eslint-disable-next-line no-unused-vars
    obterCSTICMS ({commit}) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/produto/csticms`, params: {}, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    // eslint-disable-next-line no-unused-vars
    obterCSTPIS ({commit}) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/produto/cstpis`, params: {}, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    // eslint-disable-next-line no-unused-vars
    obterCSTCOFINS ({commit}) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/produto/cstcofins`, params: {}, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    pesquisaProduto ({commit}, obj) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/produto`, params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    salvarProduto ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/produto`, data: obj, method: 'POST'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    deletarProduto ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/produto/${obj}`, method: 'DELETE'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    pesquisaPreco ({commit}, obj) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/preco`, params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    salvarPreco ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/preco`, data: obj, method: 'POST'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    deletarPreco ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/preco/${obj}`, data: obj, method: 'DELETE'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    pesquisaEan ({commit}, obj) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/ean`, params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    salvarEan ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/ean`, data: obj, method: 'POST'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    deletarEan ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/ean/${obj}`, data: obj, method: 'DELETE'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /** Fatura */
    pesquisaFatura ({commit}, obj) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/fatura`, params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    obterTotalFatura ({commit}, obj) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/fatura/total`, params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    obterVendas ({commit}, obj) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/fatura/quantidadevendas`, params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    pesquisaFaturaCFE ({commit}, obj) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/fatura/cfe`, params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    fazerDownloadXMLCFE ({commit}, obj) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/fatura/cfe/downloadxml`, responseType: 'blob', params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    fazerDownloadXMLCFEIndividual({commit}, id_reg) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/fatura/cfe/downloadxml/${id_reg}`, responseType: 'blob', method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    pesquisaFaturaNFCE ({commit}, obj) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/fatura/nfce`, params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    fazerDownloadXMLNFCE ({commit}, obj) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/fatura/nfce/downloadxml`, responseType: 'blob', params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    fazerDownloadXMLNFCEIndividual({commit}, id_reg) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/fatura/nfce/downloadxml/${id_reg}`, responseType: 'blob', method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    pesquisaFaturaNaoFiscal ({commit}, obj) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/fatura/naofiscal`, params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    anularRecebimento ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/fatura/${obj.id_reg}/anularecebimento`, method: 'PUT'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    marcarComoRecebido ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/fatura/${obj.id_reg}/recebido`, method: 'PUT'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /** pdvs */
    pesquisaPDV ({commit}, obj) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/pdv`, params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    salvarPDV ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/pdv`, data: obj, method: 'POST'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    ativarPDV ({commit}, id_reg) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/pdv/disponibilizar/${id_reg}`, data: {}, method: 'PUT'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /** finalizadoras */
    pesquisaFinalizadora ({commit}, obj) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/finalizadora`, params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    salvarFinalizadora ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/finalizadora`, data: obj, method: 'POST'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    deletarFinalizadora ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/finalizadora/${obj}`, data: obj, method: 'DELETE'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    setarFinalizadoraEstornavel ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/finalizadora/estornavel/${obj}`,  method: 'POST'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /** recursos externos */
    pesquisaRecurso ({commit}, obj) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/recurso`, params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    salvarRecurso ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/recurso`, data: obj, method: 'POST'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /** prazos */

    pesquisaPrazo ({commit}, obj) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/prazo`, params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    salvarPrazo ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/prazo`, data: obj, method: 'POST'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /** planos */

    pesquisaPlano ({commit}, obj) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/plano`, params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    salvarPlano ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/plano`, data: obj, method: 'POST'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    deletarPlano ({commit}, id) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/plano/${id}`, method: 'DELETE'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /** IBPT */
    fazerUploadTabelaIBPT({commit}, obj){
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/ibpt/tabela`, data: obj, method: 'POST', headers:{'Content-Type': 'multipart/form-data'}})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /** planos */

    pesquisaParametro ({commit}, obj) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/parametro`, params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    salvarParametro ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/parametro`, data: obj, method: 'POST'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /** prazos */

    pesquisaPOS ({commit}, obj) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/pos`, params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    salvarPOS ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/pos`, data: obj, method: 'POST'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    deletarPOS ({commit}, id) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/pos/${id}`, method: 'DELETE'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /** empregado */

    pesquisaEmpregado ({commit}, obj) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/empregado`, params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    salvarEmpregado ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/empregado`, data: obj, method: 'POST'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    deletarEmpregado ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/empregado/${obj}`, method: 'DELETE'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /** usuario */

    pesquisaUsuario ({commit}, obj) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/usuario`, params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    salvarUsuario ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/usuario`, data: obj, method: 'POST'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    alterarUsuario ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/usuario/${obj.id}`, data: obj, method: 'PUT'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /* pedido */
    pesquisaPedido ({commit}, obj) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/pedido`, params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    deletarPedido ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/pedido/${obj}`, method: 'DELETE'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    emitirNFCeOffLine ({commit}, obj) {
      return new Promise((resolve, reject) => { 
        axioss({url:`${process.env.VUE_APP_URL_API}/api/fatura/nfce/autorizaoffline/${obj.id_reg}`, method: 'POST'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            commit('erro', err.response.data.message);
            reject(err)
          })
      })
    },

    inutilizarNumeroNFCe ({commit}, obj) {
      return new Promise((resolve, reject) => { 
        axioss({url:`${process.env.VUE_APP_URL_API}/api/fatura/nfce/inutilizacao`, data: obj, method: 'POST'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            commit('erro', err.response.data.message);
            reject(err)
          })
      })
    },

    pesquisarNumerosInutilizadosNFCe({commit}){
      commit('t')
      return new Promise((resolve, reject) => { 
        axioss({url:`${process.env.VUE_APP_URL_API}/api/fatura/nfce/inutilizacao`, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    pesquisaSMTP({commit}, obj){
      commit('t')
      return new Promise((resolve, reject) => { 
        axioss({url:`${process.env.VUE_APP_URL_API}/api/smtp`, params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    salvarSMTP ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/smtp`, data: obj, method: 'POST'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /** Movimento Financeiro */
    pesquisaMovimentoFinanceiro ({commit}, obj) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/movimentofinanceiro`, params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    anularRecebimentoMovimentoFinanceiro ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/movimentofinanceiro/${obj.id_reg}/anularecebimento`, method: 'PUT'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    marcarComoRecebidoMovimentoFinanceiro ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/movimentofinanceiro/${obj.id_reg}/recebido`, method: 'PUT'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /** MFE */

    pesquisaMFE ({commit}, obj) {
      commit('t')
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/mfe`, params: obj, method: 'GET'})
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    salvarMFE ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/mfe`, data: obj, method: 'POST'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            commit('erro', err.response.data.erros.map(function(e) {return e.message}).join(', '))
            reject(err)
          })
      })
    },

    deletarMFE ({commit}, obj) {
      return new Promise((resolve, reject) => {
        axioss({url:`${process.env.VUE_APP_URL_API}/api/mfe/${obj}`, data: obj, method: 'DELETE'})
          .then(resp => {
            commit('sucesso', 'Operação ralizada com sucesso');
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

  },
  modules: {
  },
  getters : {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
  }
})
